import { render } from "./CustomIndex.vue?vue&type=template&id=6a81ebbe"
import script from "./CustomIndex.vue?vue&type=script&lang=ts"
export * from "./CustomIndex.vue?vue&type=script&lang=ts"
script.render = render

export default script